import Order from "../components/order/order";

import mountReactComponents from "../src/render_components";
import "./translations";

I18n.locale = $('html').attr('lang');
mountReactComponents({ Order });
